import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard'
import styles from './App.module.scss';
import { AppShell, Title, Container, Text, Stack, Button, Grid, Space, Box, Group, Alert, AspectRatio, Affix, LoadingOverlay } from '@mantine/core';
//import ContactModal from '../contact-modal/ContactModal';
import EmailForm from '../email-form/EmailForm';
import GeneralModalMaker from '../general-modal-maker/GeneralModalMaker';
import NotifyForm from '../notify-form/NotifyForm';
import ContactForm from '../contact-form/ContactForm';
import ContactFormGeneric from '../contact-form-generic/ContactFormGeneric';
import { useDispatch, useSelector } from 'react-redux';
import { store } from '../../redux/store';
import { getZipFileUrl, makeOrder } from '../../services/api'
import { findMappingToStudio } from '../../utils/url-utils';
import {
  selectAllDownloadable, selectBrochures, selectContactSuccessful, selectDrawings, selectValidTill, selectCurrentEmail,
  selectConfigurationId, selectProductType, selectValidUrlParams, selectLinkInfo, selectDesignId,
  selectCadGenerationFailed, selectCountryCode, selectCdProductType, selectShowContactForm, selectCDProducts, selectCDUri, selectInitialized, selectNotifyState, appActions, selectOrderHasBeenMade, selectSecondUserEmail, selectProductCode
} from '../../redux/appSlice';
import useStyles from '../../hooks/useStyles';
import { AVAILABLE, Doc, FAILED, IN_PROGRESS, WAITING } from '../../redux/types';
import DocButton from '../doc-button/DocButton';
import {
  CircleSelected, Copy, CreateDoc, DownloadIconBlue, DownloadIconWhite, Edit, FailedIcon, InfoCircle, InfoCircleRed,
  LinkComponet, Message, MessageWhite
} from '../icons/Icons';
import Header from '../header/Header';
import GiveFeedbackButton from '../GiveFeedbackButton/GiveFeedbackButton';
import cdAdd from '../../assets/images/cd_add.png'
import appStore from '../../assets/images/appstore_badge.png'
import playStore from '../../assets/images/playstore_badge.png'
import loading from '../../assets/images/loading.gif'
import useTranslation from '../../hooks/useTranslation';
import { useRecaptcha } from '../reCaptcha/useRecaptcha'
import LandingModal from '../landing-modal/LandingModal';

function App() {

  const [sendShareLink, setSendShareLink] = useState(false)
  const [resendEmail, setResendEmail] = useState(false)
  const [contactKone, setContactKone] = useState(false)
  const [requestingCad, setRequestingCad] = useState(false)

  const dispatch = useDispatch()
  const initialized = useSelector(selectInitialized)
  const brochures = useSelector(selectBrochures)
  const drawings = useSelector(selectDrawings)
  const allDownloadable = useSelector(selectAllDownloadable)
  const contactSuccessful = useSelector(selectContactSuccessful)
  const failedCadGenerationDetected = useSelector(selectCadGenerationFailed)
  const productCode = useSelector(selectProductCode)
  const configurationId = useSelector(selectConfigurationId)
  const designId = useSelector(selectDesignId)
  const productType = useSelector(selectProductType)
  const currentEmail = useSelector(selectCurrentEmail)
  const secondUSerEmail = useSelector(selectSecondUserEmail)
  const countryCode = useSelector(selectCountryCode)
  const cdProduct = useSelector(selectCdProductType)
  const frontlineCDProducts = useSelector(selectCDProducts)
  const cdUri = useSelector(selectCDUri)
  const showContactFormOnly = useSelector(selectShowContactForm)
  const notifyState = useSelector(selectNotifyState)
  const orderHasBeenMade = useSelector(selectOrderHasBeenMade)

  const validTillValue = useSelector(selectValidTill)
  const validTill = new Date(validTillValue)
  const validDate = validTill.getDate() + '.' + (validTill.getMonth() + 1) + '.' + validTill.getFullYear()

  const urlParamsAreCorrect = useSelector(selectValidUrlParams)
  // const requestIsReady = useSelector(selectRequestReachedTheBackend)

  // const readyToProceed = urlParamsAreCorrect && requestIsReady

  const linkInfo = useSelector(selectLinkInfo)

  // const typeCapitalized = productType && productType.charAt(0).toUpperCase() + productType.slice(1)

  const t = useTranslation()
  const { classes } = useStyles();

  const executeRecaptcha = useRecaptcha('download_kone_com', { visible: true })

  const editLink = linkInfo?.hostName !== ''
    ? 'http://' + linkInfo?.hostName + '/ext/AutoLogin?localeCode=' + linkInfo?.localeId + '&user_id=' + linkInfo?.uId + '&link_id=' + linkInfo?.linkId + '&pla=%2Fspr%2Fcustom%2Fjpoc%2Fhtml%2F66804%3Fid%3D' + designId + '%26action%3Dclone'
    : '#'
  const newLink = linkInfo?.hostName !== ''
    ? (findMappingToStudio(linkInfo?.hostName ?? '') ?? 'http://' + linkInfo?.hostName + '/ext/AutoLogin?user_id=' + linkInfo?.uId + '&link_id=' + linkInfo?.linkId)
    : '#'

  let cdLink = cdUri
  if (frontlineCDProducts?.products?.length > 0) {
    frontlineCDProducts?.products?.forEach((item: any) => {
      if (item.id === cdProduct) {
        const buildingType = item.modernization ? 'existing-buildings' : 'new-buildings'
        cdLink = cdUri + '/#/' + buildingType + '/' + String(countryCode).toLowerCase() + '/' + cdProduct + '/edit/blank'
      }
    })
  }

  const onDownloadAllClick = async () => {
    const url = await getZipFileUrl(store)
    const dl = document.createElement('a')
    dl.setAttribute('href', url)
    dl.setAttribute('download', configurationId + '_all_files.zip')
    dl.click()
  }

  const onGenerate = async (params: Doc) => {
    setRequestingCad(true)
    const { recaptchaToken, recaptchaNumber } = await executeRecaptcha('download_kone_com')
    await makeOrder(store, { ...params.orderForm, recaptchaToken, recaptchaNumber })
    setRequestingCad(false)
  }

  const getActionButton = (drawing: any, index: number) => {
    if (drawing.state !== AVAILABLE) return null;

    const is3DRestricted =
      drawing.type === '3D' &&
      (productCode === 'AMO' || productCode === 'HCM');

    if (is3DRestricted) {
      return (
        <Button
          classNames={{ root:styles.contactKone, label: styles.buttonLabel }} style={{ width: '130px', height: '28px' }}
          onClick={() => setContactKone(true)}
        >Contact Kone
        </Button>
      );
    }

    // Default: Generate button
    return (
      <Button
        classNames={{ root: styles.buttonRoot, label: styles.buttonLabel }}
        onClick={() => {
          onGenerate(drawing);
          dispatch(
            appActions.updateDrawingState({
              drawing: { ...drawing, state: "Waiting" },
              index
            })
          );
        }}
      >
        Generate
      </Button>
    );
  };

  // window.onbeforeunload = function (e) {
  //   if(currentEmail === '') {
  //     e.preventDefault();
  //     e.returnValue = '';
  //   }
  // }

  return (
    <AppShell
      className={styles.App}
      padding="md"
      header={<Header contactFormHeader={showContactFormOnly} headerLabel={(showContactFormOnly ? (productType === 'escalator' ? 'ui-main-page-esc-planner' : 'ui-main-page-elev-planner') : '')} />}
    >
      <Container size="lg" p={0}>
        {!showContactFormOnly && <Title align='center' order={1}>{t('ui-main-page-title')}</Title>}
        <Space h='xl' />

        {urlParamsAreCorrect &&
          <Box sx={(theme) => ({
            backgroundColor: theme.colors.gray[2],
            padding: "24px 18px"
          })}>

            <Space h='md' />
            <Title align='center' order={2}>{t('product-' + productCode)}</Title>
            <Space h='xl' />
            <Text align='center'>{t('ui-main-page-configuration-id-label')} {configurationId}</Text>
            {(productType !== ' ') &&
              <Text align='center'>{t('ui-main-page-planner-link-label')} <a href={'http://' + linkInfo?.hostName}>{productType === 'escalator' ? t('ui-main-page-esc-planner') : t('ui-main-page-elev-planner')}</a></Text>
            }

            {(contactSuccessful && currentEmail !== '') &&
              <>
                <Space h='xs' />
                <Alert icon={<CircleSelected />} color="green" className={classes.alertBox}>{t('ui-alert-thank-you-for-contacting')}</Alert>
                <Space h='xs' />
              </>
            }

            {failedCadGenerationDetected &&
              <>
                <Space h='xs' />
                <Alert icon={<InfoCircleRed />} color="red" className={classes.alertBox}>{t('ui-alert-generating-failed')}</Alert>
                <Space h='xs' />
              </>
            }

            {(!allDownloadable && currentEmail !== '') &&
              <>
                <Space h='xs' />
                <Alert icon={<InfoCircle />} color="blue" className={classes.alertBox}>
                  {t('ui-alert-files-are-being-generated-long')} <span className={styles.emailAddress}>{currentEmail}</span>.
                  <div onClick={() => setResendEmail(true)} className={styles.resendEmail}>
                    {t('ui-main-page-edit-email')}
                  </div>
                </Alert>
                <Space h='xs' />
              </>
            }

            {(allDownloadable && currentEmail !== '') &&
              <>
                <Space h='xs' />
                <Alert icon={<InfoCircle />} color="blue" className={classes.alertBox}>
                  {t('ui-alert-files-are-ready')} <span className={styles.emailAddress}>{currentEmail}</span>.
                  <div onClick={() => setResendEmail(true)} className={styles.resendEmail}>
                    {t('ui-main-page-edit-email')}
                  </div>
                </Alert>
                <Space h='xs' />
              </>
            }

            {(orderHasBeenMade && currentEmail === '' && !secondUSerEmail && !allDownloadable) &&
              <>
                <Space h='xs' />
                <Alert icon={<InfoCircle />} color="blue" className={classes.alertBox}>
                  {t('ui-alert-files-are-being-generated-ask-for-email')} <span className={styles.emailAddress}>{currentEmail}</span>.
                  <div onClick={() => setResendEmail(true)} className={styles.resendEmail}>
                    {t('ui-main-page-add-notify-email')}
                  </div>
                </Alert>
                <Space h='xs' />
              </>
            }

            {(!allDownloadable && currentEmail === '' && secondUSerEmail) &&
              <>
                <Space h='xs' />
                <Alert icon={<InfoCircle />} color="blue" className={classes.alertBox}>
                  {t('ui-alert-files-are-being-generated-long')} <span className={styles.emailAddress}>{secondUSerEmail}</span>.
                  <div onClick={() => setResendEmail(true)} className={styles.resendEmail}>
                    {t('ui-main-page-edit-email')}
                  </div>
                </Alert>
                <Space h='xs' />
              </>
            }

            <Grid>
              <Grid.Col md={6}>
                <Title order={3}>{t('ui-main-page-brochure-header')}</Title>
                <Space h='md' />
                <Stack spacing={4}>
                  {brochures.map((brochure: any, index: number) => (
                    <DocButton
                      key={index}
                      rightIcon={<DownloadIconBlue />}
                      failedIcon={<FailedIcon />}
                      loading={brochure.state === WAITING}
                      failed={brochure.state === FAILED}
                      href={brochure.url}
                    >
                      {t(brochure.name)}
                    </DocButton>
                  ))}
                </Stack>
              </Grid.Col>

              <Grid.Col md={6}>
                <Title order={3}>{t('ui-main-page-cad-files-header')}</Title>
                <Space h='md' />
                {
                <Stack spacing={4}>
                  {drawings.map((drawing: any, index: number) => (
                    <DocButton
                      key={index}
                      leftIcon={`(${drawing.type})`}
                      rightIcon={<DownloadIconBlue />}
                      failedIcon={<FailedIcon />}
                      loading={drawing.state === IN_PROGRESS || drawing.state === WAITING}
                      failed={drawing.state === FAILED}
                      href={drawing.url}
                      button={getActionButton(drawing, index)}
                      description={drawing.description && t(drawing.description)}
                    >
                      {t(drawing.name)}
                    </DocButton>
                  ))}
                </Stack>}
              </Grid.Col>
            </Grid>

            <Space h='md' />
            <Button
              size='lg'
              fullWidth={true}
              disabled={!allDownloadable}
              uppercase
              className={classes.downloadAllFiles}
              leftIcon={<DownloadIconWhite />}
              onClick={() => onDownloadAllClick()}
            >
              {t("ui-main-page-download-all")}
            </Button>
            <Space h='md' />

            <Box
              sx={(theme) => ({
                backgroundColor: theme.colors.gray[1],
                padding: "20px 24px"
              }
              )}>
              <div className={styles.shareDesign}>
                <div className={styles.shareDesignIcon}>
                  <LinkComponet size={40} />
                </div>
                <div className={styles.shareDesignBody}>
                  <Title order={4} className={styles.uppercase}>{t('ui-main-page-share-design')}</Title>
                  <Text><a href={window.location.href}>{window.location.href}</a></Text>
                  <Text>{t('ui-main-page-share-link-notice')}</Text>
                  <Text>{t('ui-main-page-valid-label')} {validDate}</Text>
                </div>
                <div className={styles.shareDesignActions}>
                  <CopyToClipboard text={window.location.href}>
                    <Button leftIcon={<Copy />} variant="subtle" className={classes.subtleAction}>{t('ui-main-page-copy-link')}</Button>
                  </CopyToClipboard>
                  <Button leftIcon={<Message />} variant="subtle" className={classes.subtleAction} onClick={() => setSendShareLink(true)} >{t('ui-main-page-email-link')}</Button>
                </div>
              </div>
            </Box>

            <Space h='lg' />
            <Group direction='column' position='center' spacing={8}>
              <a href={editLink} target="_blank" rel="noreferrer">
                <Button leftIcon={<Edit />} variant="subtle" className={classes.subtleAction}>{t('ui-main-page-edit-configuration')}</Button>
              </a>
              {/* <Button leftIcon={<Copy />} variant="subtle" className={classes.subtleAction}>Copy this configuration</Button> */}
              <a href={newLink} target="_blank" rel="noreferrer">
                <Button leftIcon={<CreateDoc />} variant="subtle" className={classes.subtleAction}>{t('ui-main-page-new-configuration')}</Button>
              </a>
            </Group>
          </Box>
        }

        {(productType === 'elevator' && !showContactFormOnly && cdLink !== '') &&
          <>
            <Space h='xl' />
            <Title align='center' order={2}>{t('ui-main-page-car-designer-ad-title')}</Title>
            <Space h='md' />
            <div className={styles.cdAd}>
              <img src={cdAdd} />
              <Space h='md' />
              <Text align='center'>{t('ui-main-page-cd-ad-text')}</Text>
              <Space h='md' />
              <a href={cdLink} target="_blank" rel="noreferrer">
                <Button
                  size='xl'
                  fullWidth={false}
                  uppercase
                  className={classes.downloadAllFiles}
                >
                  {t("ui-main-page-cd-go-to")}
                </Button>
              </a>
              <Space h='md' />
              <Text className={styles.mobileStores}>{t('ui-main-page-cd-mobile-ad-text')}</Text>
              <Space h='md' />
              <div className={styles.storeLinks}>
                <a
                  className={styles.appStoreLink}
                  href="https://apps.apple.com/app/kone-car-designer-app/id1490402365"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={appStore}
                    alt={t('ui-general-ios-app')}
                    className={styles.storeImage}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.kone.cardesignerapp"
                  className={styles.playStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={playStore}
                    alt={t('ui-general-android-app')}
                    className={styles.storeImage}
                  />
                </a>
              </div>
            </div>
          </>
        }

        {showContactFormOnly && (productType === 'escalator' || productType === 'elevator') &&
          <ContactFormGeneric executeRecaptcha={executeRecaptcha} contactType={productType} />
        }

        {!showContactFormOnly &&
          <>
            <Space h='xl' />
            <Title align='center' order={3}>{t('ui-main-page-check-videos')}</Title>
            <Space h='md' />
            {/*         <Group direction='column' position='center' p={0}>
              <a href='#'>This is how we deliver</a>
              <a href='#'>Tomorrow's People Flow</a>
            </Group>
            <Space h='xl' /> */}
            <Grid>
              <Grid.Col md={6}>
                <AspectRatio ratio={16 / 9}>
                  <iframe width="100%" height="100%" src="https://www.youtube.com/embed/b99W7_cQES4" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </AspectRatio>
              </Grid.Col>
              <Grid.Col md={6}>
                <AspectRatio ratio={16 / 9}>
                  <iframe width="100%" height="100%" src="https://www.youtube.com/embed/caWJzlEhggA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </AspectRatio>
              </Grid.Col>
            </Grid>
            <Space h='xl' />
            <Text align='center' size='sm' color="gray">{t('ui-main-page-legal-notice')}</Text>
          </>
        }
        <Space h={40} />

        {(initialized && urlParamsAreCorrect && notifyState === 'ready') &&
          <div className={styles.feedbackButtonContainer}>
            <GiveFeedbackButton stickRight={true} executeRecaptcha={executeRecaptcha} />
          </div>
        }
      </Container>



      {(urlParamsAreCorrect && !contactSuccessful) &&
        <Affix position={{ bottom: 0, left: 0, right: 0 }} className={classes.floatingContact} >
          <div className={styles.contactKone} onClick={() => setContactKone(true)}>
            <div className={styles.contactIcon}><MessageWhite width={30} height={23} /></div>
            <div className={styles.contactText}>{t('ui-main-page-contact-kone')}</div>
            <div className={styles.contactIcon}><div style={{ width: '30px', height: '23px' }}></div></div>
          </div>
        </Affix>
      }

      {/* { urlParamsAreCorrect &&
        <ContactModal executeRecaptcha={executeRecaptcha}/>
      */}

      {sendShareLink &&
        <GeneralModalMaker>
          <EmailForm executeRecaptcha={executeRecaptcha} onCancel={() => setSendShareLink(false)} />
        </GeneralModalMaker>
      }

      {resendEmail &&
        <GeneralModalMaker>
          <NotifyForm executeRecaptcha={executeRecaptcha} onCancel={() => setResendEmail(false)} onSuccess={() => setResendEmail(false)} sendLabel={(secondUSerEmail || currentEmail !== '') ? "ui-general-resend" : ""} />
        </GeneralModalMaker>
      }

      {contactKone &&
        <GeneralModalMaker>
          <ContactForm executeRecaptcha={executeRecaptcha} onCancel={() => setContactKone(false)} onSuccess={() => setContactKone(false)} hasBeenShared={window.sessionStorage.getItem("currentEmail") === null} />
        </GeneralModalMaker>
      }

      {urlParamsAreCorrect && notifyState !== 'ready' && <LandingModal executeRecaptcha={executeRecaptcha} />}

      <LoadingOverlay
        visible={!initialized}
        overlayOpacity={1}
        loader={<img src={loading} width="128" height="128" />}
        classNames={{ root: styles.loadingOverlayRoot }}
      />

      <LoadingOverlay
        visible={requestingCad}
      />

    </AppShell>
  );
}

export default App;
